import { API, Auth } from "aws-amplify";
import {
  listUserRoles,
  listUsers,
  getTeaRetinaFileUploadDetail,
  getTeaRetinaImageUploadDetail,
  getBrokers,
  getConfigurationsData,
  postConfigurationsData,
  listAuditTrails,
  listBenchmarkData,
  listModelData,
  listBenchmarkResults,
  listBenchmarkJobs,
  listDeploymentJobs,
  listCompatibleModels,
  listUserGroups,
  listBatchesbyUser,
  listBatchItem,
  getLastLabeledBatchItemByUser,
  listPriorities,
  getLabelFilesByFileName,
  getLabelFileProgressByUser,
  getLabelFilesCount,
  listYears,
  getWeeks,
  listLotsFromAuction,
  documentDBAction,
  getAuditRecords,
  getLatestModel,
  getLatestModelDetails,
  getLabelFileProgressByUserCount,
  getMixingDataBySale,
  getRepeatedCount,
  getAllMixingStatus,
  getCatalogYears,
  getCatalogSaleCodes,
  getCatalogLotsByBroker,
  GetAllLabelFiles,
  LabelingGetAllLabelFiles,
  GetAssignedFiles,
  GetAssignedFileRecord,
  LabelingGetAssignedFiles,
  LabelingGetAssignedFileRecord,
  LabelingGetJobTypes,
  listAnnotationJobs,
  listAllAnnotationJobs,
  getAnnotationRecords,
  getAnnotationResults,
  listAnnotationLabels,
  getGradesForSale,
  getAllGradeBoundaries,
  getGravityMachineLotCounts,
  getsellingmarks
} from "src/graphql/queries";
import config from "src/graphql-exports";
import {
  createUser,
  uploadFile,
  processFile,
  InvokeBatchUpload,
  MarkBatchProgressByUser,
  CaptureLabelingResult,
  MarkBatchCompletionByUser,
  CreateUserGroup,
  InvokeFileProcessSfns,
  AddUserToLabelFile,
  RemoveUserFromLabelFile,
  RemoveLabelFileData,
  deleteUserGroupById,
  manageEnvironments,
  startBenchmark,
  UploadModel,
  updateModelData,
  executePipeline,
  deleteModelData,
  addBenchmarkData,
  deleteBenchmarkData,
  updateBenchmarkData,
  updateCompatibleModel,
  RequestMixingLots,
  updateMixingSummaryStatus,
  updateMixingCollectingStatus,
  updateMixingCompletionStatus,
  updateMixingMissingCaptureCompletionStatus,
  updateMixingData,
  ProcessLabelFile,
  LabelingProcessLabelFile,
  RemoveLabelFile,
  LabelingRemoveLabelFile,
  AssignUserToLabelFile,
  LabelingAssignUserToLabelFile,
  LabelingRemoveUserFromLabelFile,
  SubmitLabelFileResult,
  LabelingSubmitLabelFileResult,
  SetLabelFileCompletion,
  LabelingSetLabelFileCompletion,
  createAnnotationJob,
  createAnnotationLabel,
  saveAnnotations,
  deleteAnnotationJob as deleteAnnotationJobMutation,
  deleteAnnotationResult as deleteAnnotationResultMutation,
  processCatalogTextFile,
  editSellingMark
} from "src/graphql/mutations";
import { Option } from "src/content/dashboards/OptionChecker";
import { IntelligentFilterResponse } from "src/content/dashboards/TypeDefs";
import { FilterDefinition } from "src/content/dashboards/TypeDefs";

API.configure(config);

export async function getAudit() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getAuditRecords,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function loadAllUserRoles() {
  const session = await Auth.currentSession();
  return API.graphql({
    query: listUserRoles,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getUsers() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listUsers,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getUserGroups() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listUserGroups,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAuditTrails() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listAuditTrails,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getBenchmarkData() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listBenchmarkData,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function addBenchmarkDataQuery(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: addBenchmarkData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function deleteBenchmarkDataQuery(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: deleteBenchmarkData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function editBenchmarkDataQuery(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateBenchmarkData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function editCompatibleModel(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateCompatibleModel,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getModelData() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listModelData,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLatestModelName(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLatestModel,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLatestModelInformation(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLatestModelDetails,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function runPipeline(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: executePipeline,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getBenchmarkResults(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listBenchmarkResults,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getBenchmarkJobs() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listBenchmarkJobs,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getDeploymentJobs() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listDeploymentJobs,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getCompatibleModels() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listCompatibleModels,
    authToken: session.getIdToken().getJwtToken(),
  });
}
export async function getBrokersList() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getBrokers,
    authToken: session.getIdToken().getJwtToken(),
  });
}
export async function getSellingMarksList() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getsellingmarks,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getCatalogsYears() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getCatalogYears,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getCatalogsSaleCodes(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getCatalogSaleCodes,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getCatalogsLotsByBroker(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getCatalogLotsByBroker,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}
export async function getPriorityLevels() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listPriorities,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelFilesDataByFileName(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLabelFilesByFileName,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLoggedUserEmail() {
  const data = await Auth.currentAuthenticatedUser();
  const userLoggedIn = data.attributes.email;
  return userLoggedIn;
}

export async function getBatchesByUser(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listBatchesbyUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getBatchItem(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listBatchItem,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchLabelFileProgressByUser(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLabelFileProgressByUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchLabelFileProgressByUserCount(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLabelFileProgressByUserCount,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function assignLabelFileToUser(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: AddUserToLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}
export async function removeUserGroupById(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: deleteUserGroupById,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function removeUserFromLabelFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: RemoveUserFromLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function StartBenchmark(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: startBenchmark,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function uploadModel(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: UploadModel,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function UpdateModelData(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateModelData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function deleteModelDataFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: deleteModelData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelFileCount() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLabelFilesCount,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getUserProgress(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getLastLabeledBatchItemByUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function runDocumentDBAction(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: documentDBAction,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function updateUserProgress(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: MarkBatchProgressByUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function updateLabelingResult(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: CaptureLabelingResult,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function updateBatchCompletion(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: MarkBatchCompletionByUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function StartBatchUpload(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: InvokeBatchUpload,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function StartFileProcess(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: InvokeFileProcessSfns,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getTeaRetinaFileUploadResults(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getTeaRetinaFileUploadDetail,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getTeaRetinaImageUploadResults(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getTeaRetinaImageUploadDetail,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fileUpload(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: uploadFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fileProcess(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: processFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAuctionYearList(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listYears,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAuctionSaleCodeList(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getWeeks,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAuctionLotNoList(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listLotsFromAuction,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function listUploadedFiles(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getTeaRetinaFileUploadDetail,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function insertUserGroup(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: CreateUserGroup,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function postConfigurations(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: postConfigurationsData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getConfigurations(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getConfigurationsData,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function registerUser(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: createUser,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function filterValues(queryStr, params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: queryStr,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function manageEnvironmentsRequest(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: manageEnvironments,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAllLabelFiles(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: GetAllLabelFiles,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelingAllLabelFiles(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingGetAllLabelFiles,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAssignedLabelFiles(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: GetAssignedFiles,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelingAssignedFiles(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingGetAssignedFiles,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getAssignedLabelFileRecord(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: GetAssignedFileRecord,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelingAssignedFileRecord(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingGetAssignedFileRecord,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function getLabelingJobTypes() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingGetJobTypes,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function processLabelFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: ProcessLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function processLabelingFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingProcessLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function removeLabelFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: RemoveLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function removeLabelingFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingRemoveLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function EditSellingMark(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: editSellingMark,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function assignUserToLabelFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: AssignUserToLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function assignUserToLabelingFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingAssignUserToLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function removeUserToLabelFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: RemoveUserFromLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function removeUserFromLabelingFile(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingRemoveUserFromLabelFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function submitLabelFileResult(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: SubmitLabelFileResult,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function submitLabelingFileResult(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingSubmitLabelFileResult,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setLabelFileCompletion(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: SetLabelFileCompletion,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setLabelingFileCompletion(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: LabelingSetLabelFileCompletion,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchMixingData(params: { table: string; sale: string }) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getMixingDataBySale,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchRepeatedCount(params: { sale: string }) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getRepeatedCount,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchAllMixingStatus() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getAllMixingStatus,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function updateMixingDataStatus(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateMixingData,
    variables: {
      table: params.table,
      lot: params.lot,
      ind: params.ind,
      sale: params.sale,
      status: params.status,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function requestMixingLots(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: RequestMixingLots,
    variables: {
      user: params.user,
      sale_code: params.sale_code,
      count: params.count,
      status: params.status,
      starting_box: params.starting_box,
      image_folder: params.image_folder,
      time: params.time,
      check_missed: params.check_missed,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setMixingSummaryStatus(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateMixingSummaryStatus,
    variables: {
      sale_code: params.sale_code,
      status: params.status,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setMixingMissingCaptureCompletionStatus(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateMixingMissingCaptureCompletionStatus,
    variables: {
      sale_code: params.sale_code,
      status: params.status,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setMixingCollectingStatus(params) {
  console.log("Params in setMixingCollectingStatus:", params);
  console.log("Query being used:", updateMixingCollectingStatus);
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateMixingCollectingStatus,
    variables: {
      sale_code: params.sale_code,
      status: params.status,
      user: params.user,
      count: params.count,
      time: params.time,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function setMixingCompletionStatus(params) {
  console.log("Params in setMixingCompletionStatus:", params);
  console.log("Query being used:", updateMixingCompletionStatus);
  const session = await Auth.currentSession();
  return await API.graphql({
    query: updateMixingCompletionStatus,
    variables: {
      sale_code: params.sale_code,
      status: params.status,
      user: params.user,
      count: params.count,
      time: params.time,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function signOut(nav) {
  try {
    await Auth.signOut();
    nav("/");
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

export function convertToOption(array: IntelligentFilterResponse[]) {
  return array.map((ele) => {
    return { label: ele.value, value: ele.value };
  });
}

export async function createFile(url: string, name: string) {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type: "image/jpeg",
  };
  const file = new File([data], name + ".jpg", metadata);
  return file;
}

export const loadYears = () => {
  const year = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 7; i++) {
    years.push((year - i).toString());
  }
  return years;
};

export const loadSaleCodes = () => {
  const weeks = [];
  for (let i = 1; i < 50; i++) {
    weeks.push(i.toString());
  }
  return weeks;
};

export async function processCatalogTextFileUpload(params) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: processCatalogTextFile,
    variables: params,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export function getGraphKeys(array: string[]) {
  console.log(array);
  const r = [],
    max = array.length - 1;
  function helper(arr, i) {
    for (let j = 0, l = array[i].length; j < l; j++) {
      const a = arr.slice(0);
      a.push(array[i][j]);
      if (i == max) r.push(a);
      else helper(a, i + 1);
    }
  }
  helper([], 0);
  return r;
}

export const genSpaces = (num: number) => {
  return " ".repeat(num);
};

export const concatToStrFromArray = (arr: FilterDefinition, sep: string) => {
  const retVal = arr.value.reduce(
    (acc: string, val: string) => (acc += val + sep),
    ""
  );
  return retVal.slice(0, -1);
};

export function convertToStringArray(array: Option[]) {
  return array.map((ele) => ele.label);
}

export const validText = (value, regex) => {
  const currentEmail = value;
  if (!regex.test(currentEmail.replace(/\s/g, ""))) {
    return false;
  }
  return true;
};

export function getHomePage(role) {
  if (role === "Admin") {
    return "/dashboards/tearetina";
  } else if (role === "Standard User") {
    return "/dashboards/tearetina";
  } else if (role === "Operator") {
    return "/file-management/catalogs";
  }
}

interface Filters {
  field_name?: string;
  operator?: string;
  value?: string;
  field_type?: string;
}

export function generateFilter(
  brokerData: string,
  std: string,
  startDateData: string,
  endDateData: string
) {
  const arr = [];
  // Add filter for brokerData if it's provided
  if (std) {
    const filter: Filters = {};
    filter.field_name = "first_taste_std_1";
    filter.operator = "eq";
    filter.value = std;
    filter.field_type = "string";
    arr.push(filter);
  }

  if (brokerData) {
    const filter: Filters = {};
    filter.field_name = "broker_id";
    filter.operator = "eq";
    filter.value = brokerData;
    filter.field_type = "string";
    arr.push(filter);
  }

  // Add filter for startDateData if it's provided
  if (startDateData) {
    // If startDateData is provided, construct a greater than or equal to filter
    const filter: Filters = {};
    filter.field_name = "sale_date_x";
    filter.operator = "gte";
    filter.value = startDateData;
    filter.field_type = "date";
    arr.push(filter);
  }

  // Add filter for endDateData if it's provided
  if (endDateData) {
    const filter: Filters = {};
    filter.field_name = "sale_date_x";
    filter.operator = "lte";
    filter.value = endDateData;
    filter.field_type = "date";
    arr.push(filter);
  }

  return arr;
}

// Function to group data by a specific field
export function groupBy(data, keyExtractor) {
  return data.reduce((result, item) => {
    const key = keyExtractor(item);
    console.log(key);
    if (key !== undefined) {
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    }
  }, {});
}

// Function to get the week number of a date
export function getWeekNumber(date) {
  const d: any = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
  const week1: any = new Date(d.getFullYear(), 0, 4);
  return (
    1 +
    Math.round(((d - week1) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
  );
}

//Annotation Tool
export async function fetchAllLabels() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listAnnotationLabels,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchAnnotationRecords(jobId: number, userName: string) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getAnnotationRecords,
    variables: {
      jobId: jobId,
      userName: userName,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchAnnotationResults(
  recordId: number,
  userName: string
) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: getAnnotationResults,
    variables: {
      recordId: recordId,
      userName: userName,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function saveAnnotationData(
  jobId: number,
  recordId: number,
  userName: string,
  status: string,
  annotations: any[]
) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: saveAnnotations,
    variables: {
      annotation_files_id: jobId,
      annotation_file_records_id: recordId,
      user_name: userName,
      status: status,
      annotations: annotations,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function deleteAnnotationResult(
  resultId: number,
  userName: string
) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: deleteAnnotationResultMutation,
    variables: { resultId, userName },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function createNewLabel(name: string, color: string) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: createAnnotationLabel,
    variables: {
      name: name,
      color: color,
    },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function fetchAssignedJobs(userEmail: string) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listAnnotationJobs,
    variables: { userEmail: userEmail },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export const createAnnotationJobRecord = async (
  jobName: string,
  s3FileKey: string,
  assignedUsers: string[],
  assignedBy: string,
  allowedLabelIds: number[]
) => {
  try {
    const apiResponse = await API.graphql({
      query: createAnnotationJob,
      variables: {
        name: jobName,
        s3FileKey: s3FileKey,
        assignedUsers: assignedUsers,
        assignedBy: assignedBy,
        allowedLabelIds: allowedLabelIds,
      },
    });

    return apiResponse;
  } catch (error) {
    console.error("Error in createAnnotationJobRecord utility: ", error);
    throw error;
  }
};

export async function fetchAllAssignedJobs() {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: listAllAnnotationJobs,
    authToken: session.getIdToken().getJwtToken(),
  });
}

export async function deleteAnnotationJob(jobId: number) {
  const session = await Auth.currentSession();
  return await API.graphql({
    query: deleteAnnotationJobMutation,
    variables: { jobId },
    authToken: session.getIdToken().getJwtToken(),
  });
}

export const fetchGradesForSaleData = async (
  year: number,
  saleCode: number,
  brokerCode: string
) => {
  try {
    const apiResponse = await API.graphql({
      query: getGradesForSale,
      variables: {
        year: year,
        saleCode: saleCode,
        brokerCode: brokerCode,
      },
    });

    return apiResponse;
  } catch (error) {
    console.error("Error in fetchGradesForSaleData utility: ", error);
    throw error;
  }
};

export const fetchGravityMachineLotCounts = async (
  startDate: string,
  endDate: string
) => {
  try {
    const apiResponse = await API.graphql({
      query: getGravityMachineLotCounts,
      variables: {
        startDate: startDate,
        endDate: endDate,
      },
    });

    return apiResponse;
  } catch (error) {
    console.error("Error in fetchGravityMachineLotCounts utility: ", error);
    throw error;
  }
};

export const fetchAllGradeBoundaries = async () => {
  try {
    const apiResponse = await API.graphql({
      query: getAllGradeBoundaries,
    });

    return apiResponse;
  } catch (error) {
    console.error("Error in fetchAllGradeBoundaries utility: ", error);
    throw error;
  }
};
